import { ReactElement } from 'react'
import { ColorRepresentation, Euler } from 'three'
import { ImmutableVector3 } from '@modugen/ui-toolkit'

interface Props {
  position: ImmutableVector3
  color?: string | ColorRepresentation
  rotationX?: number
  rotationZ?: number
  visible?: boolean
  diameter?: number
  thickness?: number
}

const RADIAL_SEGMENTS = 32
const TUBULAR_SEGMENTS = 16

const SimpleTorusMesh = ({
  position,
  color = 'green',
  rotationX = 0,
  rotationZ = 0,
  visible = true,
  diameter = 0.2,
  thickness = 0.02,
}: Props): ReactElement => {
  const radius = diameter / 2 - thickness / 2
  const tube = thickness / 2

  return (
    <mesh position={position.v} rotation={new Euler(rotationX, 0, rotationZ)} visible={visible}>
      <torusGeometry attach="geometry" args={[radius, tube, RADIAL_SEGMENTS, TUBULAR_SEGMENTS]} />
      <meshStandardMaterial color={color as ColorRepresentation} depthTest={true} />
    </mesh>
  )
}

export default SimpleTorusMesh
